$font_family:
  Galano Grotesque,
  Segoe UI,
  sans-serif;
.inputContainer {
  width: 100%;
  box-sizing: border-box;
  position: relative;

  .textInput {
    width: 100%;
    box-sizing: border-box;
    padding-left: 12px;
    padding-right: 42px;
    font-family: $font_family;
  }

  .noBorder {
    border: none;
  }

  .icon {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    left: 12px;
    cursor: pointer;
    font-size: 20px;

    &.iconClickable {
      cursor: pointer;
      pointer-events: auto;
    }
  }

  .withIcon {
    padding-left: 44px;
  }

  .validIcon {
    top: 50%;
    transform: translate(0, -50%);
    right: 6px;
  }

  .clearIcon {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: 24px;
    height: 18px;
    cursor: pointer;
    display: none;

    &.active {
      display: flex;
      align-items: center;
    }
  }
}

.withFeedback {
  width: 100%;
}
